import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// state： 存储状态（ 变量）
// getters： 对数据获取之前的再次编译， 可以理解为state的计算属性。 我们在组件中使用 $sotre.getters.fun()
// mutations： 修改状态， 并且是同步的。 在组件中使用$store.commit('', params)。 这个和我们组件中的自定义事件类似
// actions： 异步操作。 在组件中使用是$store.dispath('')
// modules： store的子模块， 为了开发大型项目， 方便状态管理而使用的。 这里我们就不解释了， 用起来和上面的一样

// let logout = {
//     icon: res.data.icon,
//     nick: res.data.nickname,
//     phone: res.data.phone
// };
// this.$store.commit("userInfo", logout);
// $store.state.user

// let carnum = localStorage.getItem("carNum") ? localStorage.getItem("carNum") : 0
let token = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : null
const state = {
    // count: carnum,
    user: {},
    token: token
}

/**
 * mutations 里面放置的是我们操作state对象属性的方法
 */
const mutations = {
    // modify(state, value) {
    //     return (state.count = value)
    // },
    // userInfo(state, value) {
    //     console.log(state, value)
    //     return (state.user = value)
    // },
    // userToken(state, value) {
    //     console.log(state, value)
    //     return (state.token = value)
    // }
}
/**
 * actions 里面放置的是我们操作state对象属性的方法
 */
const actions = {
    // modify(state, value) {
    //     return (state.count = value)
    // },
    userInfo(state, value) {
        console.log(state, value)
        return (state.user = value)
    },
    userToken(state, value) {
        console.log(state, value)
        return (state.token = value)
    }
}
export default new Vuex.Store({
    state,
    mutations,
    actions
})